import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class OpenFileHelperService {
	private readonly _blobRevokeFallbackMs = 120000;

	openBlobInNewTab(data: BlobPart | Blob, mimeType?: string): boolean {
		if (!data) {
			return false;
		}

		// The browser decides how to render the new tab from the blob's own type. Files downloaded
		// through the API arrive as application/octet-stream (or with no type at all), so an
		// explicit mimeType must always win - otherwise PDF bytes get content-sniffed as plain text.
		const currentType = data instanceof Blob ? data.type : '';
		const type = mimeType || currentType;
		const blob = data instanceof Blob && currentType === type ? data : new Blob([data as BlobPart], { type });
		const blobUrl = URL.createObjectURL(blob);

		const newWindow = window.open(blobUrl, '_blank', 'noopener,noreferrer');
		if (!newWindow) {
			URL.revokeObjectURL(blobUrl);
			return false;
		}

		setTimeout(() => URL.revokeObjectURL(blobUrl), this._blobRevokeFallbackMs);
		return true;
	}

	openUrlInNewTab(url: string): boolean {
		if (!url) {
			return false;
		}

		return !!window.open(url, '_blank', 'noopener,noreferrer');
	}
}
